export default __webpack_public_path__ + "static/media/home-design-agency-img-09.32132d0b.jpg";